import classNames from 'classnames';
import type { FC } from 'react';

import Icon from 'components/Icon/Icon';
import { Translation, useTranslation } from 'utils/translations';

import styles from './ErrorsList.module.scss';

type ErrorsListProps = {
  errors: string[];
  className?: string;
};

type ErrorMessageProps = {
  error: string;
};

const normalizeToSnakeCaseKey = (input: string): string => {
  return input
    .toLowerCase()
    .replace(/['"]/g, '')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '')
    .replace(/_+/g, '_');
};

const ErrorMessage = ({ error }: ErrorMessageProps) => {
  return useTranslation(normalizeToSnakeCaseKey(error)).replace(
    /(\[(?<link>[^\]]+)\]\([^)]+\))/g,
    '$<link>',
  );
};

const ErrorsList: FC<ErrorsListProps> = ({ errors, className }) => {
  if (!errors || errors.length === 0) return null;

  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles['errors-header']}>
        <Icon
          className={styles['errors-icon']}
          name="error.outline"
          height={24}
          width={24}
        />
        <span className={styles['errors-label-text']}>
          <Translation message="registration_failed_please_check_these_fields" />
        </span>
      </div>
      <ul className={styles['errors-list']}>
        {errors.map((error) => (
          <li key={error} className={styles['errors-list-item']}>
            <ErrorMessage error={error} />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ErrorsList;
